/**
 * Amazon-style add for the quote (logo-template) product form.
 *
 * Why this exists instead of the theme's stock AjaxProduct handler:
 * that handler POSTs `form.serialize()`, which silently DROPS the required
 * logo file input. This handler POSTs FormData (files included) to
 * /cart/add.js, then opens the cart drawer through the same
 * `added.ajaxProduct` contract — the shopper stays on the product page and
 * can keep adding colors/sizes of the same blank.
 *
 * Bound in the capture phase + stopPropagation, so it wins over the stock
 * bubble-phase submit handler when cart_type=drawer without editing it.
 */
(function () {
  function openDrawer(btn) {
    if (window.jQuery) {
      window.jQuery('body').trigger('added.ajaxProduct', [window.jQuery(btn)]);
    }
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} }));
  }

  function showError(form, message) {
    form.querySelectorAll('.errors').forEach(function (el) { el.remove(); });
    var div = document.createElement('div');
    div.className = 'errors text-center';
    div.textContent = message;
    form.prepend(div);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('js-quote-ajax')) return;
    e.preventDefault();
    e.stopPropagation();

    var btn = form.querySelector('.add-to-cart');
    if (btn) btn.classList.add('btn--loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (j) {
          throw new Error((j && j.description) || 'Add to cart failed.');
        });
      }
      return r.json();
    }).then(function () {
      form.querySelectorAll('.errors').forEach(function (el) { el.remove(); });
      if (btn) btn.classList.remove('btn--loading');
      openDrawer(btn);
    }).catch(function (err) {
      if (btn) btn.classList.remove('btn--loading');
      showError(form, (err && err.message) || 'Add to cart failed.');
      document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
        detail: { errorMessage: (err && err.message) || 'Add to cart failed.' }
      }));
    });
  }, true);
})();
